import React from "react";
import { webLinks } from "../../constant/constants";
import SocialLinks from "../SocialLinks/SocialLinks";
import "../../assest/css/footer.css";

const Footer = () => {
  const { website, services, about, terms, privacyPolicy } = webLinks;
  return (
    <div className="footer-basic">
      <footer>
        <SocialLinks />
        <ul className="list-inline" hidden>
          <li className="list-inline-item">
            <a href="/home">Home</a>
          </li>
          <li className="list-inline-item">
            <a href={services}>Services</a>
          </li>
          <li className="list-inline-item">
            <a href={about}>About</a>
          </li>
          <li className="list-inline-item">
            <a href={terms}>Terms</a>
          </li>
          <li className="list-inline-item">
            <a href={privacyPolicy}>Privacy Policy</a>
          </li>
        </ul>
        <p className="copyright">
          {" "}
          <a href={website}>AtDoor</a> © 2017
        </p>
      </footer>
    </div>
  );
};

export default Footer;
